export const NewStudyIcon = () => (
    <svg
        viewBox="0 0 10 40"
        width={'35%'}
        height={'60%'}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M35 21.667 30.383 7.8A1.666 1.666 0 0 0 28.8 6.667h-2.133M13.333 6.667H11.2A1.667 1.667 0 0 0 9.533 7.8L5 21.667"
            stroke="currentColor"
            strokeWidth={1.6}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20 5v13.333m15 3.334v11.666A1.666 1.666 0 0 1 33.333 35H6.667A1.667 1.667 0 0 1 5 33.333V21.667h8.333a6.666 6.666 0 1 0 13.334 0H35ZM15 13.333l5 5 5-5"
            stroke="currentColor"
            strokeWidth={1.6}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
